import { Head } from "@inertiajs/react";
import { SalonpageFooterInfo } from "./_footer";

interface LegalSection {
  title: string;
  body: string[];
}

interface LegalPageProps {
  title: string;
  description: string;
  updatedAt: string;
  sections: LegalSection[];
}

export function LegalPage({ title, description, updatedAt, sections }: LegalPageProps) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>

      <div className="min-h-screen bg-gray-100 text-zinc-950 antialiased">
        <main className="mx-auto min-h-screen max-w-[448px] overflow-hidden rounded-b-[22px] bg-white shadow-[0_0_24px_rgba(15,23,42,0.08)]">
          <header className="border-b border-gray-100 px-4 py-4">
            <a href="/salons" className="text-xs font-bold text-zinc-400">← サロン一覧へ</a>
            <p className="mt-6 text-xs font-black tracking-[0.18em] text-zinc-300">HAIRBOOK SALON</p>
            <h1 className="mt-2 text-2xl font-black tracking-tight">{title}</h1>
            <p className="mt-3 text-sm leading-6 text-zinc-500">{description}</p>
            <p className="mt-4 text-xs font-bold text-zinc-400">最終更新日: {updatedAt}</p>
          </header>

          <section className="space-y-7 px-4 py-6">
            {sections.map((section) => (
              <article key={section.title}>
                <h2 className="text-base font-bold tracking-tight">{section.title}</h2>
                <div className="mt-3 space-y-3 text-sm leading-7 text-zinc-700">
                  {section.body.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </section>
        </main>
        <footer className="px-4 pb-8 pt-8 text-zinc-500">
          <SalonpageFooterInfo />
        </footer>
      </div>
    </>
  );
}
